import React from 'react';

import { useEntity } from '~/hooks/use-entities';

import * as S from './NameCell.styles';

export const NameCell = ({ entityTag }: { entityTag: string }) => {
  const { data } = useEntity(entityTag);

  if (!data?.data) {
    return null;
  }

  return <S.TextCell>{data.data.name_short || data.data.name}</S.TextCell>;
};
